import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const surveydetails = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
      surveyID: null,
    },
    selectedItems: [],
    loading: true,
    saloons: [],
    SurveyID: null,
    gallery: [],
    participants: [],
    questions: [],
  }),
  mutations: {
    setSurveyDetails(state, payload) {
      state.items = payload.items;
      state.participants = payload.participants;
      state.filter.total = payload.total;
      state.questions = payload.survey.questions;
    },
    setSurveyDetailsPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getSurveyDetails");
    },
    setSurveyDetailsTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getSurveyDetails");
    },
  },
  actions: {
    async getSurveyDetails(store) {
      store.state.loading = true;
      await axios
        .post("Survey/loadresults", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setSurveyDetails", res.data.data);
        });
    },
  },
  getters: {},
};
export default surveydetails;



// WEBPACK FOOTER //
// ./src/store/surveydetails.js